import { classNames } from "common/functions";
import { Disclosure, Transition } from "@headlessui/react";
import { useState } from "react";

import styles from "./index.module.scss";

const WorkingProcess = ({ data, ...props }) => {
  // const [explainList, setExplainList] = useState([1]);
  const [explainList, setExplainList] = useState([]);

  const explainAll = (start, end, explained) => {
    while (start <= end) {
      explained[start] = 1;
      start += 1;
    }

    setExplainList(explained);
  };

  const collapseAll = (start, end, explained) => {
    while (start <= end) {
      explained[start] = -1;
      start += 1;
    }

    setExplainList(explained);
  };

  return (
    <div {...props}>
      {data &&
        Array.isArray(data) &&
        data.map((item, index) => {
          if (item.content && item.content != "") {
            return (
              <Disclosure
                key={`process-item-${index}`}
                // defaultOpen={index === 0}
              >
                {({ open }) => (
                  <>
                    <div
                      className={classNames(
                        `relative mb-4 cursor-pointer lg:mb-6`,
                        styles["container"],
                        `${
                          explainList[index] && explainList[index] !== -1
                            ? styles.explained
                            : styles.collapsed
                        }`
                      )}
                      onClick={() => {
                        const explained = [...explainList];
                        if (explained[index] && explained[index] !== -1) {
                          explained[index] = -1;
                          collapseAll(index + 1, data.length - 1, explained);
                        } else {
                          explained[index] = 1;
                          explainAll(0, index - 1, explained);
                        }
                      }}
                    >
                      <Disclosure.Button
                        className={`relative flex w-full items-center justify-between space-x-4`}
                      >
                        <div
                          className={`flex items-center justify-start space-x-4`}
                        >
                          <span className={styles["content-icon"]}>
                            {item.icon}
                          </span>
                          <span
                            className={`text-gleads-oxfordBlue-800 ${styles["content-text"]}`}
                          >
                            {/* {index + 1}. {item.name} */}
                            {item.name}
                          </span>
                        </div>
                        <div
                          className={classNames(
                            styles["explain-button"],
                            `${
                              explainList[index] &&
                              explainList[index] !== -1 &&
                              "before:rotate-90"
                            }`
                          )}
                        ></div>
                      </Disclosure.Button>
                      <Transition
                        as="div"
                        className={"relative"}
                        show={explainList[index] && explainList[index] !== -1}
                        enter="transition-all duration-600 linear"
                        enterFrom="transform max-h-0 h-0 opacity-50"
                        enterTo="transform max-h-[400px] h-fit opacity-100"
                        leave="transition-all duration-150 linear"
                        leaveFrom="transform max-h-[400px] opacity-100"
                        leaveTo="transform max-h-0 opacity-0"
                      >
                        <Disclosure.Panel className={styles["panel"]}>
                          <div
                            dangerouslySetInnerHTML={{
                              __html: item.content,
                            }}
                          ></div>
                        </Disclosure.Panel>
                      </Transition>
                    </div>
                  </>
                )}
              </Disclosure>
            );
          } else {
            return (
              <div
                key={`process-item-${index}`}
                className={classNames(
                  `relative mb-4 lg:mb-6`,
                  styles["container"],
                  styles.collapsed
                )}
              >
                <div
                  className={`relative flex w-full items-center justify-between`}
                >
                  <div className={`flex items-center justify-start space-x-4`}>
                    <span className={styles["content-icon"]}>{item.icon}</span>
                    <span className={styles["content-text"]}>{item.name}</span>
                  </div>
                </div>
              </div>
            );
          }
        })}
    </div>
  );
};

export default WorkingProcess;
